module.exports = __webpack_public_path__ + "img/programing.5fef1dd4.jpg";